import { Media, mbSize } from '@foxrenderfarm/common/src/theme'
import styled from 'styled-components'

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  position: relative;
  margin: 0;
  gap: 8px;
  cursor: pointer;
  color: #666666;
  input[type='radio'] {
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    width: 20px;
    height: 20px;
    border: 2px solid #999999;
    border-radius: 50%;
    display: grid;
    place-content: center;
  }
  input[type='radio']::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    background: #f3512b;
  }
  input[type='radio']:checked {
    border: 2px solid #f3512b;
  }
  input[type='radio']:checked::before {
    transform: scale(1);
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    input[type='radio'] {
      width: ${mbSize(30)};
      height: ${mbSize(30)};
      border: ${mbSize(3)} solid #999999;
    }
    input[type='radio']::before {
      content: '';
      width: ${mbSize(16)};
      height: ${mbSize(16)};
    }
    input[type='radio']:checked {
      border: ${mbSize(3)} solid #f3512b;
    }
  }
`

export const RadioInput = styled.input`
  cursor: pointer;
  color: transparent;
`
